var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-container",
    [
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c(
                "w-row",
                { attrs: { "no-margin": "" } },
                [
                  _c(
                    "w-button",
                    {
                      attrs: { flat: "" },
                      on: {
                        click: function ($event) {
                          return _vm.goToSettings()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "arrow-left" } })],
                    1
                  ),
                  _c("w-spacer"),
                  _c(
                    "w-button-bar",
                    [
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Eigenschappen bewerken",
                              expression: "'Eigenschappen bewerken'",
                            },
                          ],
                          on: {
                            click: function ($event) {
                              return _vm.editProperties()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "wrench" } })],
                        1
                      ),
                      _c(
                        "w-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.save()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "save" } })],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        { attrs: { grow: "", shrink: "", center: "" } },
        [
          _c(
            "transition",
            { staticClass: "fast-fade", attrs: { mode: "out-in" } },
            [
              !_vm.ready
                ? _c(
                    "w-col",
                    { attrs: { center: "" } },
                    [_c("w-progress-circular")],
                    1
                  )
                : _c(
                    "w-col",
                    { style: { height: "100%" }, attrs: { grow: "" } },
                    [
                      _c(
                        "w-card",
                        {
                          staticClass: "grow",
                          style: { maxHeight: "100%" },
                          attrs: { tag: "w-card" },
                        },
                        [
                          _c(
                            "w-card-title",
                            [
                              _c("w-input", {
                                attrs: { label: "Naam", fancy: "" },
                                model: {
                                  value: _vm.button.Label,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.button, "Label", $$v)
                                  },
                                  expression: "button.Label",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-scroll-view",
                            {
                              staticClass: "grow no-margin",
                              attrs: { tag: "w-col" },
                            },
                            [
                              _c("codemirror", {
                                ref: "codeEditor",
                                staticClass: "grow",
                                attrs: { options: _vm.cmOptions },
                                model: {
                                  value: _vm.button.Code,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.button, "Code", $$v)
                                  },
                                  expression: "button.Code",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-card-content",
                            { style: { flexGrow: 0, flexShrink: 0 } },
                            [
                              _c(
                                "w-row",
                                [
                                  _c(
                                    "w-col",
                                    {
                                      staticClass: "info-block",
                                      attrs: { xs: "12" },
                                    },
                                    [
                                      _c("div", [
                                        _vm._v(
                                          "Extra knoppen gebruiken javascript code om een URL te returnen dat daarna geopend moet worden."
                                        ),
                                      ]),
                                      _c("div", [
                                        _vm._v(
                                          "De functie is async dus je kan await gebruiken."
                                        ),
                                      ]),
                                      _c("div", [
                                        _vm._v("Beschikbare variabelen zijn:"),
                                      ]),
                                      _c("ul", [
                                        _c("li", [
                                          _vm._v(
                                            "services: Object met alle services in (de volledige map winfakt-online-authentication/src/services)"
                                          ),
                                        ]),
                                        _c("li", [
                                          _vm._v(
                                            " data: Context over de huidige pagina (bv. De huidige ticket) "
                                          ),
                                        ]),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.propertyEditorOpen } },
        [
          _vm.propertyEditorOpen
            ? _c("app-extra-button-edit-properties", {
                on: {
                  close: function ($event) {
                    _vm.propertyEditorOpen = false
                  },
                },
                model: {
                  value: _vm.button,
                  callback: function ($$v) {
                    _vm.button = $$v
                  },
                  expression: "button",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }